import './App.css';

import About from './components/About';
import Contact from './components/Contact';
import Experience from './components/Experience';
import ExperienceEducation from './components/ExperienceEducation';
import FloatingEmail from './components/FloatingEmail';
import Home from './components/Home';
import NavBar from './components/NavBar';
import Projects from './components/Projects';
import SocialLinks from './components/SocialLinks';

const portfolioSections = [
  Home,
  About,
  ExperienceEducation,
  Projects,
  Experience,
  Contact,
];

function App() {
  return (
    <div className="app-shell">
      <div className="noise-overlay" aria-hidden="true" />
      <NavBar />
      <SocialLinks />
      <main>
        {portfolioSections.map((Section) => (
          <Section key={Section.name} />
        ))}
      </main>
      <FloatingEmail />
    </div>
  );
}

export default App;
